import { render, staticRenderFns } from "./userTransportation.vue?vue&type=template&id=7dfdf494&"
import script from "./userTransportation.vue?vue&type=script&lang=js&"
export * from "./userTransportation.vue?vue&type=script&lang=js&"
import style0 from "./userTransportation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports